// Module
var code = "<runner-page-description is-show=\"!isMobile\" page-header-text=\"Setup\" page-description=\"Create and manage user roles.\" help-link=\"{{$ctrl.helpUri}}\"> <roles-header on-roles-updated=\"$ctrl.onRolesUpdated()\"></roles-header> </runner-page-description> <runner-setup-tabs></runner-setup-tabs> <roles-list></roles-list> ";
// Exports
export default code;